module.exports = __webpack_public_path__ + "media/images/flags/32/South-Sudan-73b20843aa829561350e4c54f469b3b6.png";